// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post/put/delete çağrılarına bağlanacak.
let mockCvs = [
    { id: 1, name: "Ahmet Yılmaz CV Türkçe", fileName: "Ahmet_Yilmaz_CV.pdf", tags: ["tr"] },
    { id: 2, name: "Ahmet Yılmaz CV İngilizce", fileName: "Ahmet_Yilmaz_CV_Guncel.pdf", tags: ["en"] }
];

let nextId = 3;

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockCvs];

    if (filter.name) {
        rows = rows.filter((row) => row.name.toLowerCase().includes(filter.name.toLowerCase()));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const get = async (id) => {
    const row = mockCvs.find((item) => item.id === Number(id));
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

const store = async (data) => {
    let name = '';
    let fileName = '';
    let tags = [];

    if (data instanceof FormData) {
        name = data.get('name') || '';
        const file = data.get('file');
        fileName = file ? file.name : '';
        const rawTags = data.get('tags');
        tags = rawTags ? JSON.parse(rawTags) : [];
    } else {
        name = data.name || '';
        fileName = data.file ? data.file.name : (data.fileName || '');
        tags = data.tags || [];
    }

    const row = {
        id: nextId++,
        name,
        fileName,
        tags
    };
    mockCvs.push(row);
    return Promise.resolve({
        data: {
            data: row,
            message: "coop_cv_added_success"
        }
    });
};

const update = async (id, data) => {
    const index = mockCvs.findIndex((item) => item.id === Number(id));
    if (index !== -1) {
        let name = '';
        let fileName = mockCvs[index].fileName;
        let tags = [];

        if (data instanceof FormData) {
            name = data.get('name') || '';
            const file = data.get('file');
            if (file) {
                fileName = file.name;
            }
            const rawTags = data.get('tags');
            tags = rawTags ? JSON.parse(rawTags) : [];
        } else {
            name = data.name || '';
            if (data.file) {
                fileName = data.file.name;
            } else if (data.fileName) {
                fileName = data.fileName;
            }
            tags = data.tags || [];
        }

        mockCvs[index] = {
            ...mockCvs[index],
            name,
            fileName,
            tags
        };
    }
    return Promise.resolve({
        data: {
            data: mockCvs[index],
            message: "successfully_updated"
        }
    });
};

const remove = async (id) => {
    mockCvs = mockCvs.filter((item) => item.id !== Number(id));
    return Promise.resolve({
        data: {
            message: "successfully_deleted"
        }
    });
};

// Eski metotlarla uyumluluk için alias tanımları
const create = store;

export default {
    getAll,
    get,
    store,
    create,
    update,
    remove
}
